export const COMPONENT_NAME = "verification-modal";
